import { Link } from "react-router-dom";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found | Mirai Educations", description: "This page does not exist. Go back to the Mirai Educations homepage for free online-degree counselling.", path: "/", noindex: true });
  return (
    <main className="mx-auto max-w-3xl px-5 py-28 sm:px-8" data-testid="not-found-page">
      <p className="font-display text-xs font-bold uppercase tracking-[0.2em] text-ink">404</p>
      <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">Page not found</h1>
      <p className="mt-6 text-base text-night">The page you are looking for does not exist or has moved.</p>
      <Link to="/" className="mt-10 inline-flex rounded-full bg-sun px-7 py-3.5 font-display font-extrabold text-night" data-testid="not-found-home-link">Go to homepage</Link>
    </main>
  );
}
